/*
Controller: MfpNumbers

Operations:
  getMfpNumbers
*/
var Api = require('../config')
var MfpNumbersRequestDef = require('../definitions/MfpNumbersRequest')

var MfpNumbers = (function () {
  /*
  Operation: getMfpNumbers
  Get all MFP numbers
  Parameters:

  Responses:
    HTTP 200: Aggregated MFP Numbers response
    HTTP 400: Invalid request
  */
  function getMfpNumbersMfpNumbers (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        MfpNumbersRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/mfp-numbers'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getMfpNumbers'] = getMfpNumbersMfpNumbers
  return ret
})()

module.exports = MfpNumbers
